<mat-tab-group class="mat-tab-group-principal" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="{{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}">
    <form>
      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

            <div fxFlex="33" fxFlex.lt-md="100%">
              <div fxLayout="column" class="flexwrap">

                @if (calibration.id == null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentList.filter.client.label' | translate
                      }}</mat-label>
                      <mat-select #clientSelect name="idClientSelected"
                        [(ngModel)]="idClientSelected">
                        @if (clientSelect.focused) {
                          <mat-select-filter [displayMember]="'name'"
                            [array]="clients" (filteredReturn)="clientsFiltered =$event"
                            [noResultsMessage]="'common.noResults' | translate"
                          [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
                        }
                        <mat-option value="-1"> -- {{ 'calibrationResponsibleType.internal' |
                          translate | uppercase }} --
                        </mat-option>
                        @for (client of clientsFiltered; track client) {
                          <mat-option [value]="client.id">
                            {{client.name}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }

                @if (calibration.id == null && idClientSelected != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' |
                      translate }}</mat-label>
                      <input matInput [ngModel]="equipment.name" #trigger="matAutocompleteTrigger"
                        [matAutocomplete]="auto" (keyup)="lookupEquipment($event)"
                        [ngModelOptions]="{standalone: true}">
                      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                        [displayWith]="displayFn"
                        (optionSelected)="onSensorChange($event, trigger)">
                        @for (item of equipmentAutoComplete; track item; let index = $index) {
                          <mat-option
                            [value]="item">
                            {{ item.name}} ({{item.serialNum}})
                          </mat-option>
                        }
                      </mat-autocomplete>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (calibration.id == null && idClientSelected != null) {
                  <div fxFlex>
                    <a class="under-card-link" style="cursor: pointer;margin: inherit;"
                      (click)="createEquipment()">
                      {{ 'calibrateEquipmentEdit.general.equipment.notExists' | translate }}
                    </a>
                  </div>
                }

                @if (calibration.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.name.label' | translate
                      }}</mat-label>
                      <input matInput name="name" [(ngModel)]="equipment.name" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.name.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.equipment.label' | translate
                      }}</mat-label>
                      <input matInput name="equipment" [(ngModel)]="equipment.equipment" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.equipment.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.maker.label' | translate
                      }}</mat-label>
                      <input matInput name="maker" [(ngModel)]="equipment.maker" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.maker.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.model.label' | translate
                      }}</mat-label>
                      <input matInput name="model" [(ngModel)]="equipment.model" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.model.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.serialNum.label' | translate
                      }}</mat-label>
                      <input matInput name="serialNum" [(ngModel)]="equipment.serialNum" disabled>
                      <mat-error>
                        {{ 'calibrateEquipmentEdit.general.serialNum.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }

                @if (equipment.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.location.label' | translate
                      }}</mat-label>
                      <input matInput name="location" [(ngModel)]="equipment.location" disabled>
                    </mat-form-field>
                  </div>
                }

              </div>
            </div>

            <div fxFlex="33" fxFlex.lt-md="100%">

              <div fxLayout="column" class="flexwrap">

                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.certificateNum.label' | translate
                    }}</mat-label>
                    <input matInput name="certificateNum" [(ngModel)]="calibration.certificateNum"
                      [disabled]="isEditable()">
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.certificateNum.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex>
                  <mat-form-field style="width: 95%;">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.calibrateDate.label' | translate
                    }}</mat-label>
                    <input matInput [matDatepicker]="calibrateDate" name="calibrationDate"
                      [ngModel]="calibration.calibrationDate"
                      (blur)="saveDate('calibrationDate', $event)"
                      (dateChange)="saveDate('calibrationDate', $event)" [disabled]="isEditable()"
                      [max]="maxDateCalibration">
                    <mat-datepicker-toggle matSuffix [for]="calibrateDate"></mat-datepicker-toggle>
                    <mat-datepicker #calibrateDate>
                    </mat-datepicker>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.calibrateDate.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex>
                  <mat-form-field style="width: 95%;">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.expirationDate.label' | translate
                    }}</mat-label>
                    <input matInput [matDatepicker]="expirationDate" name="expirationDate"
                      [ngModel]="calibration.expirationDate"
                      (blur)="saveDate('expirationDate', $event)"
                      (dateChange)="saveDate('expirationDate', $event)" [disabled]="isEditable()">
                    <mat-datepicker-toggle matSuffix [for]="expirationDate"></mat-datepicker-toggle>
                    <mat-datepicker #expirationDate>
                    </mat-datepicker>
                    <mat-error>
                      {{ 'calibrateEquipmentEdit.general.expirationDate.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>

                @if (calibration.id != null) {
                  <div fxFlex>
                    <mat-checkbox name="showExpirationDate"
                      [(ngModel)]="calibration.showExpirationDate">
                      {{'calibrateEquipmentEdit.general.showExpirationDate.label' | translate }}
                    </mat-checkbox>
                  </div>
                }

                <div fxFlex>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'calibrateEquipmentEdit.general.projectNumber.label' | translate
                    }}</mat-label>
                    <input matInput name="projectNo" [(ngModel)]="calibration.projectNo"
                      [disabled]="isEditable()">
                  </mat-form-field>
                </div>

                @if (calibration.id != null) {
                  <div fxFlex>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'calibrateEquipmentEdit.general.status.label' | translate
                      }}</mat-label>
                      <mat-select name="idStatus" [(ngModel)]="calibration.idStatus" disabled>
                        @for (item of statuses; track item) {
                          <mat-option [value]="item.id">
                            {{ 'calibrationStatus.' + item.translation | translate }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                }

                @if (calibration.currentVersion > 0 && calibration.currentVersion != null) {
                  <div fxFlex
                    >
                    <div fxLayout="row">
                      <div fxFlex="50">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'calibrateEquipmentEdit.general.currentVersion.label' |
                          translate }}</mat-label>
                          <input matInput name="currentVersion"
                            [ngModel]="calibration.currentVersion" disabled>
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'calibrateEquipmentEdit.general.signedVersion.label' |
                          translate }}</mat-label>
                          <input matInput name="signedVersion"
                            [ngModel]="calibration.signedVersion" disabled>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }

              </div>

            </div>

            @if (equipment.id != null) {
              <div fxFlex="33" fxFlex.lt-md="100%">
                <div fxLayout="column" class="flexwrap">
                  <div fxFlex>
                    <mat-form-field style="width: 95%;">
                      <mat-label>{{ 'calibrateEquipmentEdit.client.name.label' | translate
                      }}</mat-label>
                      <input matInput name="clientName" [value]="clientName" disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex>
                    <mat-label>{{ 'calibrateEquipmentEdit.client.address.label' | translate
                    }}</mat-label>
                    <textarea matInput [value]="clientAddress" name="clientAddress"
                    style="resize: none;" disabled> </textarea>
                  </div>
                </div>
              </div>
            }

          </div>

        </mat-card-content>
      </mat-card>

      @if (calibration.id != null) {
        <mat-card class="card">
          <mat-card-content>
            <mat-toolbar color="secondary">
              {{ 'calibrateEquipmentEdit.environmentalConditions.title' | translate }}
            </mat-toolbar>
            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.place.label' | translate
                  }}</mat-label>
                  <mat-select required name="idPlace" [(ngModel)]="calibration.idPlace"
                    [disabled]="isEditable()">
                    @for (item of places; track item) {
                      <mat-option [value]="item.id">
                        {{ 'calibrationPlace.' + item.translation | translate }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.calibrationData.place.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.temperature.label' |
                  translate }}</mat-label>
                  <input matInput name="temperature" [(ngModel)]="calibration.temperature"
                    [disabled]="isEditable()">
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.environmentalConditions.temperature.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.humidity.label' |
                  translate }}</mat-label>
                  <input matInput name="humidity" [(ngModel)]="calibration.humidity"
                    [disabled]="isEditable()">
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.environmentalConditions.humidity.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibrateEquipmentEdit.environmentalConditions.pressure.label' |
                  translate }}</mat-label>
                  <input matInput name="pressure" [(ngModel)]="calibration.pressure"
                    [disabled]="isEditable()">
                  <mat-error>
                    {{ 'calibrateEquipmentEdit.environmentalConditions.pressure.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
              <div fxFlex="30" fxFlex.lt-md="100%">
                {{ 'calibrateEquipmentEdit.calibrationData.variables.label' | translate }}:
                <mat-select multiple [(ngModel)]="variablesSelected" name="idsVariable"
                  [disabled]="isEditable()">
                  @for (item of variables; track item) {
                    <mat-option checkboxPosition="before" [value]="item"
                      (onSelectionChange)="onChangeVariableCheck($event)">
                      {{ 'variable.' + item.translation | translate }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }

      @if (calibration.id != null) {
        <mat-card class="card">
          <mat-card-content>
            <mat-tab-group style="width: 100%;" (selectedTabChange)="onVariableTabChange($event)">
              @for (variable of calibration.variables; track variable; let indexVariable = $index) {
                <mat-tab
                  style="min-height: 50vh;"
                  label="{{'variable.' + variable.variableTranslation | translate }}">
                  <mat-card class="card">
                    <mat-card-content>
                      <mat-toolbar color="secondary">
                        {{ 'calibrateEquipmentEdit.general.title' | translate : {variable: ('variable.'
                        +
                        variable.variableTranslation | translate) } }}
                      </mat-toolbar>
                      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                        <div fxFlex="20" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.unit.label' |
                            translate }}</mat-label>
                            <mat-select name="unit{{variable.idVariable}}"
                              [(ngModel)]="variable.idUnit" required
                              (selectionChange)="onUnitChange(indexVariable, $event)"
                              [disabled]="isEditable()">
                              @for (item of variableUnits; track item) {
                                <mat-option [value]="item.id">
                                  {{item.unit}}
                                </mat-option>
                              }
                            </mat-select>
                            <mat-error>
                              {{ 'calibrateEquipmentEdit.calibrationData.unit.error' | translate
                              }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div fxFlex="30" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.procedure.label' |
                              translate }}
                            </mat-label>
                            <mat-select #procedureSelect required name="idProcedure{{variable.idVariable}}"
                              [(ngModel)]="variable.idProcedure" [disabled]="isEditable()" panelClass="select-with-search">
                              @if (procedureSelect.focused) {
                                <mat-select-filter [displayMember]="'description'"
                                  [array]="procedures" (filteredReturn)="filteredProcedures =$event"
                                  [noResultsMessage]="'common.noResults' | translate"
                                [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
                              }
                              @for (item of filteredProcedures; track item) {
                                <mat-option [value]="item.id">
                                  {{ item.name }} ({{ item.description }})
                                </mat-option>
                              }
                            </mat-select>
                            <mat-error>
                              {{ 'calibrateEquipmentEdit.calibrationData.procedure.error' |
                              translate }}
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <div fxFlex="50" fxFlex.lt-md="100%">
                          <mat-form-field class="campoFormulario">
                            <mat-label>{{ 'calibrateEquipmentEdit.balance.essayType.label' |
                            translate }}</mat-label>
                            <mat-select multiple [(ngModel)]="variable.idsEssayType"
                              name="idsEssayType{{indexVariable}}" [disabled]="isEditable()">
                              @for (item of balanceEssayTypes; track item) {
                                <mat-option
                                  checkboxPosition="before" [value]="item.id"
                                  [disabled]="onChangeDisableEssay(item.id)"
                                  (onSelectionChange)="onChangeEssayCheck(indexVariable, $event)">
                                  {{ item.name | translate }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      <div>
                        <mat-card class="card-content">
                          <mat-card-content>
                            <mat-toolbar color="secondary">
                              {{ 'calibrateEquipmentEdit.calibrationData.title' | translate }}
                              @if (!isEditable()) {
                                <button mat-icon-button color="accent"
                                  (click)="newConfigRow(indexVariable)">
                                  <mat-icon>add</mat-icon>
                                </button>
                              }
                            </mat-toolbar>
                            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
                              <table #configTable mat-table matSort
                                [dataSource]="variable.configs" style="width: 100%;">
                                <!-- range Column -->
                                <ng-container matColumnDef="range">
                                  <th mat-header-cell *matHeaderCellDef>
                                    {{ 'calibrateEquipmentEdit.config.cols.range' |
                                  translate }} </th>
                                  <td mat-cell *matCellDef="let item">
                                    <div style="white-space: pre-line;">
                                      @if (item.rangeInit != null && item.rangeEnd != null) {
                                        <span
                                          >
                                          {{ item.rangeInit }} - {{ item.rangeEnd }}
                                          {{variable.unitName}}
                                        </span>
                                      }
                                      @if (item.rangeInit != null && item.rangeEnd == null) {
                                        <span
                                          >
                                          {{ item.rangeInit }} {{variable.unitName}}
                                        </span>
                                      }
                                    </div>
                                  </td>
                                </ng-container>
                                <!-- resolution Column -->
                                <ng-container matColumnDef="resolution">
                                  <th mat-header-cell *matHeaderCellDef>
                                    {{ 'calibrateEquipmentEdit.config.cols.resolution' |
                                  translate }} </th>
                                  <td mat-cell *matCellDef="let item">
                                    <div style="white-space: pre-line;"> {{ item.resolution
                                    }} </div>
                                  </td>
                                </ng-container>
                                <!-- tolerance Column -->
                                <ng-container matColumnDef="tolerance">
                                  <th mat-header-cell *matHeaderCellDef>
                                    {{ 'calibrateEquipmentEdit.config.cols.tolerance' |
                                  translate }} </th>
                                  <td mat-cell *matCellDef="let item">
                                    <div style="white-space: pre-line;"> {{ item.tolerance
                                    }} </div>
                                  </td>
                                </ng-container>
                                <!-- uncertaintyResolution Column -->
                                <ng-container matColumnDef="uncertaintyResolution">
                                  <th mat-header-cell *matHeaderCellDef>
                                    {{
                                    'calibrateEquipmentEdit.config.cols.uncertaintyResolution'
                                  | translate }} </th>
                                  <td mat-cell *matCellDef="let item">
                                    <div style="white-space: pre-line;"> {{
                                    item.uncertaintyResolution }} </div>
                                  </td>
                                </ng-container>
                                <!-- Values Column -->
                                <ng-container matColumnDef="values">
                                  <th mat-header-cell *matHeaderCellDef>
                                    {{ 'calibrateEquipmentEdit.asLeft.cols.value.label' |
                                  translate }} </th>
                                  <td mat-cell *matCellDef="let item">
                                  {{showConfigPoints(item.points)}} </td>
                                </ng-container>
                                <!-- Button edit Column -->
                                <ng-container matColumnDef="edit">
                                  <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' |
                                  translate }} </th>
                                  <td mat-cell *matCellDef="let element; let i = index">
                                    @if (!isEditable()) {
                                      <button mat-icon-button
                                        (click)="editConfigRow(indexVariable, i)"
                                        >
                                        <mat-icon>mode_edit</mat-icon>
                                      </button>
                                    }
                                  </td>
                                </ng-container>
                                <!-- Button delete Column -->
                                <ng-container matColumnDef="delete">
                                  <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' |
                                  translate }} </th>
                                  <td mat-cell *matCellDef="let element; let i = index">
                                    @if (!isEditable()) {
                                      <button mat-icon-button
                                        (click)="deleteConfigRow(indexVariable, i)"
                                        >
                                        <mat-icon>delete</mat-icon>
                                      </button>
                                    }
                                  </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="configCols"></tr>
                                <tr mat-row *matRowDef="let row; columns: configCols;"></tr>
                              </table>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <div>
                        <mat-card class="card-content">
                          <mat-card-content>
                            <mat-toolbar color="secondary">
                              {{ 'calibrateEquipmentEdit.pattern.title' | translate }}
                              @if (!isEditable() && !onHidePattern(indexVariable)) {
                                <button mat-icon-button color="accent"
                                  (click)="newPatternRow(indexVariable)"
                                  >
                                  <mat-icon>add</mat-icon>
                                </button>
                              }
                            </mat-toolbar>
                            <div fxLayout="column" class="flexwrap">
                              <div fxFlex>
                                <table #patternsTable mat-table matSort
                                  [dataSource]="variable.patterns" style="width: 100%;">
                                  <!-- name Column -->
                                  <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.pattern.cols.name' |
                                    translate }} </th>
                                    <td mat-cell *matCellDef="let item">
                                      <div style="white-space: pre-line;"> {{
                                      getEquipmentMaker(item.equipment, 1) }} </div>
                                    </td>
                                  </ng-container>
                                  <!-- equipment Column -->
                                  <ng-container matColumnDef="equipment">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.pattern.cols.equipment' |
                                      translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                      <div style="white-space: pre-line;"> {{
                                      getEquipmentMaker(item.equipment, 2) }} </div>
                                    </td>
                                  </ng-container>
                                  <!-- maker Column -->
                                  <ng-container matColumnDef="maker">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                      {{ 'calibrateEquipmentEdit.pattern.cols.maker' |
                                      translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let item">
                                    {{getEquipmentMaker(item.equipment, 3)}} </td>
                                  </ng-container>
                                  <!-- model Column -->
                                  <ng-container matColumnDef="model">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                      {{ 'calibrateEquipmentEdit.pattern.cols.model' |
                                    translate }} </th>
                                    <td mat-cell *matCellDef="let item">
                                    {{getEquipmentMaker(item.equipment, 4)}} </td>
                                  </ng-container>
                                  <!-- serialNum Column -->
                                  <ng-container matColumnDef="serialNum">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.pattern.cols.serialNum' |
                                      translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let item">{{
                                    getEquipmentMaker(item.equipment, 5) }} </td>
                                  </ng-container>
                                  <!-- uncertainty Column -->
                                  <ng-container matColumnDef="uncertainty">
                                    <th mat-header-cell *matHeaderCellDef>
                                      {{ 'calibrateEquipmentEdit.pattern.cols.uncertainty'
                                      | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let item">{{
                                    getWorstUncertainty(indexVariable, item) }} </td>
                                  </ng-container>
                                  <!-- Button edit Column -->
                                  <ng-container matColumnDef="edit">
                                    <th mat-header-cell *matHeaderCellDef> {{ 'button.edit'
                                    | translate }} </th>
                                    <td mat-cell *matCellDef="let element; let i = index">
                                      @if (!isEditable()) {
                                        <button mat-icon-button
                                          (click)="editPatternRow(indexVariable, i)"
                                          >
                                          <mat-icon>mode_edit</mat-icon>
                                        </button>
                                      }
                                    </td>
                                  </ng-container>
                                  <!-- Button delete Column -->
                                  <ng-container matColumnDef="delete">
                                    <th mat-header-cell *matHeaderCellDef> {{
                                    'button.delete' | translate }} </th>
                                    <td mat-cell *matCellDef="let element; let i = index">
                                      @if (!isEditable()) {
                                        <button mat-icon-button
                                          (click)="deletePatternRow(indexVariable, i)"
                                          >
                                          <mat-icon>delete</mat-icon>
                                        </button>
                                      }
                                    </td>
                                  </ng-container>
                                  <tr mat-header-row *matHeaderRowDef="patternsCols"></tr>
                                  <tr mat-row *matRowDef="let row; columns: patternsCols;">
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </mat-card-content>
                        </mat-card>
                      </div>
                      <mat-card>
                        <mat-card-content>
                          <mat-toolbar color="secondary">
                            {{ 'calibrateEquipmentEdit.asFound.title' | translate }}
                          </mat-toolbar>
                        </mat-card-content>
                        @if (variable.patterns?.length > 0) {
                          <div fxLayout="column">
                            @for (essay of variable.essays; track essay; let indexEssay = $index) {
                              <mat-card
                                style="padding: 0px;">
                                @if (essay.idEssayType === 1) {
                                  <mat-card-content style="padding: 0px;">
                                    <mat-toolbar color="secondary">
                                      {{ ('balanceEssayType.' + essay.essayTranslation | translate) }}
                                      @if (!isEditable()) {
                                        <button mat-icon-button color="accent"
                                          (click)="onEssayDataAsFound(indexVariable, essay)"
                                          >
                                          <mat-icon>view_timeline</mat-icon>
                                        </button>
                                      }
                                    </mat-toolbar>
                                    <div fxLayout="column" fxLayout.xs="column" class="flexwrap"
                                      style="margin-bottom: 10px;">
                                      <div fxLayout="column" class="flexwrap" style="width: 100%;">
                                        <div fxFlex>
                                          <table #asFoundTable mat-table
                                            [dataSource]="essay.asFound" style="width: 100%;">
                                            <!-- Number Column -->
                                            <ng-container matColumnDef="number">
                                              <th mat-header-cell *matHeaderCellDef>
                                              </th>
                                              <td mat-cell
                                                *matCellDef="let element; let i = index">
                                                {{ (i
                                              + 1) }} </td>
                                            </ng-container>
                                            <!-- Point Column -->
                                            <ng-container matColumnDef="point">
                                              <th mat-header-cell *matHeaderCellDef>
                                                {{
                                                'calibrateEquipmentEdit.asFound.cols.point.label'
                                              | translate }} </th>
                                              <td mat-cell *matCellDef="let element">
                                                {{
                                              element.point }} </td>
                                            </ng-container>
                                            <!-- Pattern Column -->
                                            <ng-container matColumnDef="pattern">
                                              <th mat-header-cell *matHeaderCellDef>
                                                {{
                                                'calibrateEquipmentEdit.asFound.cols.pattern.label'
                                              | translate }} </th>
                                              <td mat-cell *matCellDef="let element">
                                              {{ element.pattern }} </td>
                                            </ng-container>
                                            <!-- Equipment Column -->
                                            <ng-container matColumnDef="equipment">
                                              <th mat-header-cell *matHeaderCellDef>
                                                {{
                                                'calibrateEquipmentEdit.asFound.cols.equipment.label'
                                              | translate }} </th>
                                              <td mat-cell *matCellDef="let element">
                                                {{ element.equipment | number:'1.' +
                                                getDecimalsResolution(indexVariable,
                                                element.point) +
                                                '-' +
                                                getDecimalsResolution(indexVariable,
                                                element.point) }}
                                              </td>
                                            </ng-container>
                                            <!-- Correction Column -->
                                            <ng-container matColumnDef="correction">
                                              <th mat-header-cell *matHeaderCellDef>
                                                {{
                                                'calibrateEquipmentEdit.asFound.cols.correction.label'
                                              | translate }} </th>
                                              <td mat-cell *matCellDef="let element">
                                                {{
                                                getCorretionAsFound(element) }}
                                              </td>
                                            </ng-container>
                                            <!-- Button edit Column -->
                                            <ng-container matColumnDef="edit">
                                              <th mat-header-cell *matHeaderCellDef>
                                                {{
                                              'button.edit' | translate }} </th>
                                              <td mat-cell
                                                *matCellDef="let element; let i = index">
                                                @if (!isEditable()) {
                                                  <button mat-icon-button
                                                    (click)="editAsFoundRow(indexVariable, indexEssay, i)"
                                                    >
                                                    <mat-icon>mode_edit</mat-icon>
                                                  </button>
                                                }
                                              </td>
                                            </ng-container>
                                            <tr mat-header-row *matHeaderRowDef="asFoundCols">
                                            </tr>
                                            <tr mat-row
                                              *matRowDef="let row; columns: asFoundCols;">
                                            </tr>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </mat-card-content>
                                }
                              </mat-card>
                            }
                          </div>
                        }
                      </mat-card>
                      <mat-card>
                        <mat-card-content>
                          <mat-toolbar color="secondary">
                            {{ 'calibrateEquipmentEdit.asLeft.title' | translate }}
                          </mat-toolbar>
                          @if (variable.patterns?.length > 0) {
                            <div fxLayout="column">
                              @for (essay of getOrderedEssays(indexVariable); track essay; let indexEssay = $index) {
                                <mat-card
                                  style="padding: 0px;">
                                  <mat-card-content style="padding: 0px;">
                                    <mat-toolbar color="secondary">
                                      {{ ('balanceEssayType.' + essay.essayTranslation |
                                      translate) }}
                                      @if (!isEditable() && showBtnPoints(essay.idEssayType)) {
                                        <button mat-icon-button color="accent"
                                          (click)="onEssayData(indexVariable, essay)"
                                          >
                                          <mat-icon>view_timeline</mat-icon>
                                        </button>
                                      }
                                    </mat-toolbar>
                                    @if (essay.idEssayType === 1) {
                                      <div fxLayout="column" fxLayout.xs="column" class="flexwrap"
                                        style="margin-bottom: 10px;">
                                        <div fxLayout="column" class="flexwrap"
                                          style="width: 100%;">
                                          <div fxFlex>
                                            <table #asLeftTable mat-table
                                              [dataSource]="essay.asLeft"
                                              style="width: 100%;">
                                              <!-- Number Column -->
                                              <ng-container matColumnDef="number">
                                                <th mat-header-cell *matHeaderCellDef> </th>
                                                <td mat-cell
                                                  *matCellDef="let element; let i = index">
                                                  {{ (i
                                                + 1) }} </td>
                                              </ng-container>
                                              <!-- Point Column -->
                                              <ng-container matColumnDef="point">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.massPattern.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element"> {{
                                                element.point }} </td>
                                              </ng-container>
                                              <!-- Pattern Column -->
                                              <ng-container matColumnDef="pattern">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.nominal.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">{{
                                                  element.decimalPattern ? (element.pattern | number:'1.' +
                                                  element.decimalPattern + '-' + element.decimalPattern): element.pattern }}
                                                </td>
                                              </ng-container>
                                              <!-- Values Column -->
                                              <ng-container matColumnDef="value">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.reading.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  <span [matTooltip]="element.average">
                                                    {{ element.average | number:'1.' +
                                                    ((element.decimalPattern ? getDecimalsPattern(element.decimalPattern): getDecimalsResolution(indexVariable,
                                                    element.point)) +
                                                    1) + '-' +
                                                    ((element.decimalPattern ? getDecimalsPattern(element.decimalPattern):getDecimalsResolution(indexVariable,
                                                    element.point)) + 1) }}
                                                  </span>
                                                </td>
                                              </ng-container>
                                              <!-- Average Column -->
                                              <ng-container matColumnDef="average">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.correction.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  <span [matTooltip]="element.correction">
                                                    {{ element.correction | number:'1.'+
                                                    (getDecimalsResolution(indexVariable,
                                                    element.decimalPattern ? element.decimalPattern : element.point) +
                                                    1) + '-' +
                                                    (getDecimalsResolution(indexVariable,
                                                    element.point) + 1) }}
                                                  </span>
                                                </td>
                                              </ng-container>
                                              <!-- cPlusU Column -->
                                              <ng-container matColumnDef="cPlusU">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.cPlusU.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  <span
                                                    [class]="styleCPlusU(indexVariable, element.point, element.cPlusU)"
                                                    [matTooltip]="element.cPlusU">
                                                    {{ element.cPlusU | number:'1.' +
                                                    getDecimalsUncertainty(indexVariable,
                                                    element.point) +
                                                    '-' +
                                                    getDecimalsUncertainty(indexVariable,
                                                    element.point) }}
                                                  </span>
                                                </td>
                                              </ng-container>
                                              <!-- Button see Column -->
                                              <ng-container matColumnDef="edit">
                                                <th mat-header-cell *matHeaderCellDef> {{
                                                'button.edit' | translate }} </th>
                                                <td mat-cell
                                                  *matCellDef="let element; let i = index">
                                                  @if (!isEditable() && !onHideEditLeft(element)) {
                                                    <button mat-icon-button
                                                      (click)="editAsLeftRow(indexVariable, indexEssay, i)">
                                                      <mat-icon>mode_edit</mat-icon>
                                                    </button>
                                                  }
                                                </td>
                                              </ng-container>
                                              <tr mat-header-row
                                              *matHeaderRowDef="asLeftCols"></tr>
                                              <tr mat-row
                                                *matRowDef="let row; columns: asLeftCols;">
                                              </tr>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    @if (essay.idEssayType === 2) {
                                      <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
                                        style="margin-bottom: 10px;">
                                        <div fxLayout="column" class="flexwrap"
                                          style="width: 100%;">
                                          <div fxFlex>
                                            <table name="indexTable{{indexEssay}}"
                                              #asLeftTableRepetibility mat-table
                                              [dataSource]="essay.asLeft"
                                              style="width: 100%;">
                                              <!-- Number Column -->
                                              <ng-container matColumnDef="number">
                                                <th mat-header-cell *matHeaderCellDef> </th>
                                                <td mat-cell
                                                  *matCellDef="let element; let i = index">
                                                  {{ (i
                                                + 1) }} </td>
                                              </ng-container>
                                              <!-- Pattern Column -->
                                              <ng-container matColumnDef="pattern">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.nominal.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element"> {{
                                                element.pattern }} </td>
                                              </ng-container>
                                              <!-- Values Column -->
                                              <ng-container matColumnDef="value">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.value.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  {{joinListValues(indexVariable,
                                                element)}}</td>
                                              </ng-container>
                                              <!-- Devesta Column -->
                                              <ng-container matColumnDef="desvesta">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.desvesta.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  {{getDevestaValue(element) | number:'1.'
                                                  +
                                                  getDecimalsPattern(element.pattern) +
                                                  '-' +
                                                  getDecimalsPattern(element.pattern) }}
                                                </td>
                                              </ng-container>
                                              <!-- Average Column -->
                                              <ng-container matColumnDef="average">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.average.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  <span [matTooltip]="element.average">
                                                    {{ element.average | number:'1.' +
                                                    ((element.decimalPattern ? getDecimalsPattern(element.decimalPattern): getDecimalsResolution(indexVariable,
                                                    element.pattern)) +
                                                    1) + '-' +
                                                    ((element.decimalPattern ? getDecimalsPattern(element.decimalPattern):getDecimalsResolution(indexVariable,
                                                    element.pattern)) + 1) }}
                                                  </span>
                                                </td>
                                              </ng-container>
                                              <!-- Correction Column -->
                                              <ng-container matColumnDef="correction">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.asLeft.cols.correction.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  <span [matTooltip]="element.correction">
                                                    {{ element.correction | number:'1.'
                                                    +
                                                    getDecimalsPattern(element.pattern)
                                                    + '-' +
                                                    getDecimalsPattern(element.pattern)
                                                    }}
                                                  </span>
                                                </td>
                                              </ng-container>
                                              <!-- Button see Column -->
                                              <ng-container matColumnDef="edit">
                                                <th mat-header-cell *matHeaderCellDef> {{
                                                'button.edit' | translate }} </th>
                                                <td mat-cell
                                                  *matCellDef="let element; let i = index">
                                                  @if (!isEditable()) {
                                                    <button mat-icon-button
                                                      (click)="editAsLeftRow(indexVariable, indexEssay, i)">
                                                      <mat-icon>mode_edit</mat-icon>
                                                    </button>
                                                  }
                                                </td>
                                              </ng-container>
                                              <tr mat-header-row
                                              *matHeaderRowDef="asRepetibilityCols"></tr>
                                              <tr mat-row
                                                *matRowDef="let row; columns: asRepetibilityCols;">
                                              </tr>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    @if (essay.idEssayType === 3) {
                                      <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
                                        style="margin-bottom: 10px;">
                                        <div fxLayout="row" class="flexwrap" style="width: 100%;">
                                          <div fxFlex="30">
                                            <div class="figuras" fxLayout="column">
                                              <!-- Cuadrado -->
                                              <div class="container square">
                                                <div class="line-vertical"></div>
                                                <div class="line-horizontal"></div>
                                                <div class="center">C</div>
                                                <div class="quadrant q1">1</div>
                                                <div class="quadrant q2">2</div>
                                                <div class="quadrant q3">3</div>
                                                <div class="quadrant q4">4</div>
                                              </div>
                                              <!-- Círculo -->
                                              <div class="container circle">
                                                <div class="line-vertical"></div>
                                                <div class="line-horizontal"></div>
                                                <div class="center">C</div>
                                                <div class="quadrant q1">1</div>
                                                <div class="quadrant q2">2</div>
                                                <div class="quadrant q3">3</div>
                                                <div class="quadrant q4">4</div>
                                              </div>
                                            </div>
                                          </div>
                                          <div fxFlex="70" fxLayout="column">
                                            <div fxFlex="100">
                                              <div fxFlex="15" fxFlex.lt-md="100%"
                                                class="center-text">
                                                <span style="font-weight: 600;">Carga del
                                                ensayo:</span>
                                              </div>
                                              @if (vBalanceMass?.length > 0) {
                                                <div fxFlex="20" fxFlex.lt-md="100%"
                                                  >
                                                  <mat-form-field class="campoFormulario">
                                                    <mat-label>{{ 'Seleccione:' | translate
                                                    }}</mat-label>
                                                    <mat-select name="pointUnit"
                                                      [disabled]="isEditable()"
                                                      [(ngModel)]="essay.essayLoad">
                                                      @for (item of vBalanceMass; track item) {
                                                        <mat-option
                                                          [value]="item.average"
                                                          checkboxPosition="before"
                                                          [matTooltip]="(item.idMass ? item.idMass + ' - ' : '')">
                                                          {{ item.pointUnit }}
                                                        </mat-option>
                                                      }
                                                    </mat-select>
                                                  </mat-form-field>
                                                </div>
                                              }
                                            </div>
                                            <div fxLayout="column" class="flexwrap"
                                              style="width: 100%;">
                                              <div fxFlex>
                                                <table
                                                  name="indexTableEccentricity{{indexEssay}}"
                                                  #asLeftTableEccentricity mat-table
                                                  [dataSource]="essay.asLeft"
                                                  style="width: 100%;">
                                                  <!-- Number Column -->
                                                  <ng-container matColumnDef="number">
                                                    <th mat-header-cell
                                                    *matHeaderCellDef> </th>
                                                    <td mat-cell
                                                      *matCellDef="let element">
                                                      {{ element.point === 0 ? 'C' :
                                                    element.point }} </td>
                                                  </ng-container>
                                                  <!-- Values Column -->
                                                  <ng-container matColumnDef="value">
                                                    <th mat-header-cell
                                                      *matHeaderCellDef>
                                                      {{
                                                      'calibrateEquipmentEdit.asLeft.cols.value.label'
                                                    | translate }} </th>
                                                    <td mat-cell
                                                      *matCellDef="let element">
                                                      {{joinListValues(indexVariable,
                                                    element)}}</td>
                                                  </ng-container>
                                                  <!-- Button see Column -->
                                                  <ng-container matColumnDef="edit">
                                                    <th mat-header-cell
                                                      *matHeaderCellDef> {{
                                                      'button.edit' | translate }}
                                                    </th>
                                                    <td mat-cell
                                                      *matCellDef="let element; let i = index">
                                                      @if (!isEditable()) {
                                                        <button mat-icon-button
                                                          (click)="editAsLeftRow(indexVariable, indexEssay, i)">
                                                          <mat-icon>mode_edit</mat-icon>
                                                        </button>
                                                      }
                                                    </td>
                                                  </ng-container>
                                                  <tr mat-header-row
                                                    *matHeaderRowDef="asEccentricityCols">
                                                  </tr>
                                                  <tr mat-row
                                                    *matRowDef="let row; columns: asEccentricityCols;">
                                                  </tr>
                                                </table>
                                              </div>
                                            </div>
                                            <div fxFlex="100" fxLayout="column">
                                              <div fxFlex="100" fxFlex.lt-md="100%">
                                                <span>{{'calibrateEquipmentEdit.eccentricity.label'
                                                | translate }}</span>
                                              </div>
                                              @if (essay?.essayLoad) {
                                                <div fxFlex="100" fxFlex.lt-md="100%"
                                                  >
                                                  <span>{{getErrorCenter(essay) | number:'1.'
                                                    +
                                                    getDecimalsUncertainty(indexVariable,
                                                    essay?.essayLoad) +
                                                    '-' +
                                                    getDecimalsUncertainty(indexVariable,
                                                  essay?.essayLoad) }}</span>
                                                </div>
                                              }
                                            </div>
                                            <div fxFlex="100" fxLayout="column">
                                              <div fxFlex="100" fxFlex.lt-md="100%">
                                                <span>{{'calibrateEquipmentEdit.eccentricity.errorNominal'
                                                | translate}}</span>
                                              </div>
                                              @if (essay?.essayLoad) {
                                                <div fxFlex="100" fxFlex.lt-md="100%"
                                                  >
                                                  <span>{{getErrorNominal(essay) | number:'1.'
                                                    +
                                                    getDecimalsUncertainty(indexVariable,
                                                    essay?.essayLoad) +
                                                    '-' +
                                                    getDecimalsUncertainty(indexVariable,
                                                  essay?.essayLoad) }}</span>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    @if (essay.idEssayType === 4) {
                                      <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
                                        style="margin-bottom: 10px;">
                                        <div fxLayout="row" class="flexwrap" style="width: 100%;">
                                          <div fxFlex="20">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'calibrateEquipmentEdit.essay.essayPreload.label'
                                                |
                                                translate
                                              }}</mat-label>
                                              <input type="number" matInput
                                                name="essayPreload"
                                                [(ngModel)]="essay.essayPreload"
                                                (blur)="getCalculateEssayTara(essay)"
                                                [disabled]="isEditable()">
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="20">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'calibrateEquipmentEdit.essay.essayLoad.label'
                                                |
                                              translate }}</mat-label>
                                              <mat-select name="essayLoad"
                                                [(ngModel)]="essay.essayLoad"
                                                [disabled]="isEditable()"
                                                (selectionChange)="getCalculateEssayTara(essay)">
                                                @for (item of vBalanceMass; track item) {
                                                  <mat-option
                                                    [value]="item.average"
                                                    checkboxPosition="before"
                                                    [matTooltip]="(item.idMass ? item.idMass + ' - ' : '')">
                                                    {{ item.pointUnit }}
                                                  </mat-option>
                                                }
                                              </mat-select>
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="20">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'calibrateEquipmentEdit.essay.essayLoadRead.label'
                                                |
                                                translate
                                              }}</mat-label>
                                              <input matInput type="number"
                                                name="essayLoadRead"
                                                [(ngModel)]="essay.essayLoadRead"
                                                (blur)="getCalculateEssayTara(essay)"
                                                [disabled]="isEditable()">
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="20">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'calibrateEquipmentEdit.essay.grossWeight.label'
                                                |
                                                translate
                                              }}</mat-label>
                                              <input matInput name="grossWeight"
                                                [ngModel]="essay.grossWeight"
                                                [disabled]="true">
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="20">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'calibrateEquipmentEdit.essay.patternValue.label'
                                                |
                                                translate
                                              }}</mat-label>
                                              <input matInput name="patternValue"
                                                [ngModel]="essay.essayLoad"
                                                [disabled]="true">
                                            </mat-form-field>
                                          </div>
                                        </div>
                                        <div fxLayout="row" class="flexwrap" style="width: 100%;">
                                          <div fxFlex="20" fxLayout="row">
                                            <div fxFlex="100" fxFlex.lt-md="100%">
                                              <span style="font-weight: 600;">{{
                                                'calibrateEquipmentEdit.essay.error.label' |
                                              translate}}</span>
                                            </div>
                                            <div fxFlex="100" fxFlex.lt-md="100%">
                                              <span>{{essay.error | number:'1.' +
                                                getDecimalsUncertainty(indexVariable,
                                                essay?.essayLoad) +
                                                '-' + getDecimalsUncertainty(indexVariable,
                                              essay?.essayLoad) }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    @if (essay.idEssayType === 5) {
                                      <div fxLayout="column" fxLayout.xs="column" class="flexwrap"
                                        style="margin-bottom: 10px;">
                                        <div fxLayout="row" class="flexwrap" style="width: 100%;">
                                          <div fxFlex="20">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'calibrateEquipmentEdit.essay.rangeScale.label'
                                                |
                                                translate
                                              }}</mat-label>
                                              <input type="number" matInput name="rangeScale"
                                                (blur)="onBlurSpm(indexVariable, essay)"
                                                [(ngModel)]="essay.rangeScale"
                                                [disabled]="isEditable()">
                                            </mat-form-field>
                                          </div>
                                          <div fxFlex="20">
                                            <mat-form-field class="campoFormulario">
                                              <mat-label>{{
                                                'calibrateEquipmentEdit.essay.toleratedPercentage.label'
                                                | translate
                                              }}</mat-label>
                                              <input type="number" matInput
                                                name="toleratedPercentage"
                                                [(ngModel)]="essay.toleratedPercentage"
                                                (blur)="onBlurSpm(indexVariable, essay)"
                                                [disabled]="isEditable()">
                                            </mat-form-field>
                                          </div>
                                        </div>
                                        <div fxLayout="column" style="width: 100%;">
                                          <div fxFlex="100">
                                            <table name="indexTableMinimumWeight{{indexEssay}}"
                                              #asLeftTableMinimumWeight mat-table
                                              [dataSource]="essay.asLeft"
                                              style="width: 100%;">
                                              <!-- Number Column -->
                                              <ng-container matColumnDef="number">
                                                <th mat-header-cell *matHeaderCellDef> </th>
                                                <td mat-cell *matCellDef="let element">
                                                  {{ element.point }}
                                                </td>
                                              </ng-container>
                                              <!-- 2spm Column -->
                                              <ng-container matColumnDef="value">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{
                                                  'calibrateEquipmentEdit.essay.desvesta.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  {{ element.minumunResult | number:'1.' +
                                                  getDecimalsResolution(indexVariable,
                                                  element.point) + '-' +
                                                  getDecimalsResolution(indexVariable,
                                                element.point) }}</td>
                                              </ng-container>
                                              <!-- result Column -->
                                              <ng-container matColumnDef="pMResult">
                                                <th mat-header-cell *matHeaderCellDef>
                                                  {{'calibrateEquipmentEdit.essay.2spm.label'
                                                | translate }} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  {{ element.pMResult| number:'1.' +
                                                  getDecimalsResolution(indexVariable,
                                                  element.point) + '-' +
                                                  getDecimalsResolution(indexVariable,
                                                  element.point) }} {{variable.unitName}}
                                                </td>
                                              </ng-container>
                                              <!-- result Column -->
                                              <ng-container matColumnDef="820d">
                                                <th mat-header-cell *matHeaderCellDef>
                                                {{'820d'}} </th>
                                                <td mat-cell *matCellDef="let element">
                                                  {{ element.spmCalculated| number:'1.' +
                                                  getDecimalsResolution(indexVariable,
                                                  element.point) + '-' +
                                                  getDecimalsResolution(indexVariable,
                                                  element.point) }} {{variable.unitName}}
                                                </td>
                                              </ng-container>
                                              <tr mat-header-row
                                              *matHeaderRowDef="asMinimumWeightCols"></tr>
                                              <tr mat-row
                                                *matRowDef="let row; columns: asMinimumWeightCols;">
                                              </tr>
                                            </table>
                                          </div>
                                          <div fxFlex="100">
                                            <span style="font-weight: 500;">Pesada mínima
                                              asignada a la
                                              balanza: {{getPMCalculated(essay) | number:'1.'
                                              +
                                              getDecimalsResolution(essay,
                                              essay.toleratedPercentage)
                                              + '-' + getDecimalsResolution(indexVariable,
                                              essay.toleratedPercentage)}}
                                            {{variable.unitName}}</span>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </mat-card-content>
                                </mat-card>
                              }
                            </div>
                          }
                        </mat-card-content>
                      </mat-card>
                    </mat-card-content>
                  </mat-card>
                  @if (variable.patterns?.length > 0) {
                    <mat-card class="card">
                      <mat-card-content>
                        <mat-toolbar color="secondary">
                          {{ 'calibrateEquipmentEdit.uncertainties.title' | translate }}
                        </mat-toolbar>
                        <div fxLayout="column" class="flexwrap">
                          <div fxFlex>
                            <table #uncertaintiesTable mat-table
                              [dataSource]="getAsLeftList(indexVariable)" style="width: 100%;">
                              <!-- Number Column -->
                              <ng-container matColumnDef="number">
                                <th mat-header-cell *matHeaderCellDef> </th>
                                <td mat-cell *matCellDef="let element; let i = index"> {{ (i + 1) }}
                                </td>
                              </ng-container>
                              <!-- Point Column -->
                              <ng-container matColumnDef="point">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.nominal.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                  <span [matTooltip]="element.pattern">
                                    {{ element.pattern }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- uRep Column -->
                              <ng-container matColumnDef="uRep">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uRep.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.uRep">
                                    {{ element.uRep | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) + '-'
                                    + getDecimalsUncertainty(indexVariable, element.point) }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- uEcc Column -->
                              <ng-container matColumnDef="uExc">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uExc.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.uExc">
                                    {{ element.uExc | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) + '-'
                                    + getDecimalsUncertainty(indexVariable, element.point) }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- uResol Column -->
                              <ng-container matColumnDef="uResol">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uResol.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.uResol">
                                    {{ element.uResol | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) +
                                    '-' + getDecimalsUncertainty(indexVariable, element.point)
                                    }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- uResol Column -->
                              <ng-container matColumnDef="uHister">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uHister.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.uHister">
                                    {{ element.uHister ? (element.uHister | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) +
                                    '-' + getDecimalsUncertainty(indexVariable, element.point))
                                    : 'common.notApplicable' | translate }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- uPattern Column -->
                              <ng-container matColumnDef="uPattern">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uPattern.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element"> {{ joinListUP(indexVariable,
                                element) }} </td>
                              </ng-container>
                              <!-- uUnif Column -->
                              <ng-container matColumnDef="uUnif">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uUnif.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.uUnif">
                                    {{ element.uUnif != null ? element.uUnif :
                                    'common.notApplicable' | translate }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- uEstab Column -->
                              <ng-container matColumnDef="uEstab">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uEstab.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.uEstab">
                                    {{ element.uEstab | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) +
                                    '-' + getDecimalsUncertainty(indexVariable, element.point)
                                    }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- uc Column -->
                              <ng-container matColumnDef="uc">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.uc.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.uC">
                                    {{ element.uC | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) + '-' +
                                    getDecimalsUncertainty(indexVariable, element.point) }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- neff Column -->
                              <ng-container matColumnDef="neff">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.neff.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.neff">
                                    {{ element.neff | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) + '-'
                                    + getDecimalsUncertainty(indexVariable, element.point) }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- k Column -->
                              <ng-container matColumnDef="k">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.k.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.k">
                                    {{ element.k }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- U Column -->
                              <ng-container matColumnDef="U">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' |
                                translate }} </th>
                                <td mat-cell *matCellDef="let element">
                                  <span [matTooltip]="element.U">
                                    {{ element.U | number:'1.' +
                                    getDecimalsUncertainty(indexVariable, element.point) + '-' +
                                    getDecimalsUncertainty(indexVariable, element.point) }}
                                  </span>
                                </td>
                              </ng-container>
                              <!-- measureUnit Column -->
                              <ng-container matColumnDef="measureUnit">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{ 'calibrateEquipmentEdit.uncertainties.cols.measureUnit.label'
                                | translate }} </th>
                                <td mat-cell *matCellDef="let element"> {{ variable.unitName }}
                                </td>
                              </ng-container>
                              <tr mat-header-row *matHeaderRowDef="uncertaintiesCols"></tr>
                              <tr mat-row *matRowDef="let row; columns: uncertaintiesCols;"></tr>
                            </table>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  }
                </mat-tab>
              }
            </mat-tab-group>
          </mat-card-content>
        </mat-card>
      }

      <mat-card class="card">
        <mat-card-content>
          <mat-toolbar color="secondary">
            {{ 'calibrateEquipmentEdit.observations.title' | translate }}
          </mat-toolbar>

          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

            <div fxFlex="80" fxFlex.lt-md="100%">
              <mat-label>{{ 'calibrateEquipmentEdit.observations.label' | translate }}</mat-label>
              <textarea matInput
                [(ngModel)]="calibration.observations" name="observations" style="resize: none;">
              </textarea>
            </div>

          </div>

        </mat-card-content>
      </mat-card>

      @if (calibration.id != null) {
        <mat-card class="card">
          <mat-card-content>
            <mat-toolbar color="secondary">
              {{ 'calibrateEquipmentEdit.result.title' | translate }}
            </mat-toolbar>
            <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
              <div fxFlex="80" fxFlex.lt-md="100%">
                <mat-radio-group [(ngModel)]="calibration.correct" name="correct" [disabled]="isEditable()">
                  <mat-radio-button [value]="true"> {{'common.correct' | translate}} </mat-radio-button>
                  <mat-radio-button [value]="false"> {{'common.incorrect' | translate}}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }

      <mat-card class="card">
        <mat-card-actions>
          <div fxFlex></div>
          @if (showRevertSign()) {
            <button mat-raised-button color="primary" (click)="revertSign()">
            {{ 'button.revertSign' | translate }} </button>
          }
          @if (showBack()) {
            <div  fxFlex="0.5"></div>
          }
          @if (showBack()) {
            <button mat-raised-button color="primary" (click)="calculateBack()">
            {{ 'button.retreat' | translate }}</button>
          }
          @if (userCanModify()) {
            <div  fxFlex="0.5"></div>
          }
          @if (userCanModify()) {
            <button mat-raised-button color="primary" (click)="saveCalibration()">
            {{ 'button.save' | translate }}</button>
          }
          @if (showAdvance()) {
            <div  fxFlex="0.5" ></div>
          }
          @if (showAdvance()) {
            <button mat-raised-button color="primary" (click)="calculateAdvance()">
            {{ 'button.advance' | translate }}</button>
          }
          @if (showManualSign()) {
            <div  fxFlex="0.5"></div>
          }
          @if (showManualSign()) {
            <button mat-raised-button color="primary" (click)="manualSign()">
            {{ 'button.sign-manual' | translate }}</button>
          }
          @if (showAutomaticSign()) {
            <div  fxFlex="0.5"></div>
          }
          @if (showAutomaticSign()) {
            <button mat-raised-button color="primary" (click)="automaticSign()">
            {{ 'button.sign-automatic' | translate }}</button>
          }
          @if (showDownloadButton()) {
            <div  fxFlex="0.5"></div>
          }
          @if (showDownloadButton()) {
            <button mat-raised-button color="accent" (click)="downloadPdf()">
            {{ 'button.download-certificate' | translate }}</button>
          }
          @if (showInvalidate()) {
            <div  fxFlex="0.5"></div>
          }
          @if (showInvalidate()) {
            <button mat-raised-button color="primary" (click)="invalidate()">
            {{ 'button.invalidate' | translate }}</button>
          }
          <div  fxFlex="0.5"></div>
          <button mat-raised-button color="secondary" (click)="cancel()">{{ 'button.cancel' | translate
          }}</button>
        </mat-card-actions>
      </mat-card>

    </form>
  </mat-tab>
  @if (calibration.id != null) {
    <mat-tab label="{{ 'calibrateEquipmentEdit.historical.title' | translate }}">
      <app-calibration-balance-edit-audit [idCalibration]="calibration.id" [documentCode]="calibration.certificateNum"
        [calibration]="calibration" [equipment]="equipment">
      </app-calibration-balance-edit-audit>
    </mat-tab>
  }
</mat-tab-group>